import { Integration, IntegrationStatus } from '../../../domain/assets';
import { IntegrationAdapter } from '../../../app/assets';
import { IntegrationDto } from '../../../api';
import { IntegrationImplConfig } from './integrationImplConfig';

export function createIntegrationImpl(config: IntegrationImplConfig): IntegrationAdapter {
    const { api } = config;
    return {
        async find(context, query) {
            const response = await api.asset.integrations.list(context, query);
            return {
                total: response.data.length,
                items: response.data.flatMap((item): Integration[] => {
                    const status = getStatus(item);
                    if (!status) {
                        return [];
                    }
                    return [
                        {
                            id: item.id,
                            definitionId: item.implementation.integration_definition_id,
                            status: status,
                            lastSyncedStartedAt:
                                typeof item.sync_status === 'object'
                                    ? item.sync_status?.started_at ?? null
                                    : null,
                            lastSyncedFinishedAt:
                                typeof item.sync_status === 'object'
                                    ? item.sync_status?.closed_at ?? null
                                    : null,
                        },
                    ];
                }),
                limit: query.page_size,
            };
        },
    };
}

function getStatus(item: IntegrationDto): IntegrationStatus | null {
    if (!item.is_connected) {
        return null;
    }
    if (item.is_data_synced) {
        return 'ready';
    }
    return 'syncing';
}
